import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import commonEn from './styles/language/en.json';
import commonId from './styles/language/id.json';
import commonCn from './styles/language/cn.json';
import commonAr from './styles/language/ar.json';

const resources = {
    en: { common: commonEn },
    id: { common: commonId },
    cn: { common: commonCn },
    ar: { common: commonAr },
};

i18n
    .use(initReactI18next) // Connects React with i18next
    .init({
        resources, // Add translation resources
        lng: 'en', // Default language
        fallbackLng: 'en', // Fallback language
        interpolation: {
            escapeValue: false, // React already escapes by default
        },
    });

export default i18n;
